import * as React from 'react';
import axios from 'axios';
import * as _ from 'lodash';
import authService from './api-authorization/AuthorizeService';

interface UserProps {
    id: number;
    driverSystem: boolean;
    skipTruckToolCheck: boolean;
    userRoles: UserRoles[];
    userBranches: UserBranches[];
    updateRoles(userRoles: UserRoles[]): void;
    updateBranches(userBranches: UserBranches[]): void;
    updateDriverSystem(driverSystem: boolean, skipTruckToolCheck: boolean): void;
    save(): void;
}

interface User {
    roleId: number;
    roles: UserRoles[];         //all roles
    availableRoles: UserRoles[];
    branchId: number;
    branches: UserBranches[];         //all branches
    availableBranches: UserBranches[];
    errors: any;
    loading: boolean;
}

interface UserRoles {
    id: number;
    name: string;
}

interface UserBranches {
    id: number;
    name: string;
}

export default class UserRole extends React.Component<UserProps, User> {
    constructor(props: UserProps) {
        super(props);
        this.state = {
            roleId: 0,
            roles: [],
            availableRoles: [],
            branchId: 0,
            branches: [],
            availableBranches: [],
            errors: {},
            loading: true
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();

        axios.get('api/User/GetRolesBranches', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ roles: res.data.roles, branches: res.data.branches, loading: false });
        });
    }

    handleRoleChange = (e: any) => {
        var userRoles = this.props.userRoles;
        var newRole: UserRoles = {
            id: parseInt(e.target.value),
            name: e.target.selectedOptions[0].label
        };
        userRoles.push(newRole);

        //check if Driver, Truck Team Lead or Truck Labourer added and if so set Driver System to True
        if (newRole.name === "Driver" || newRole.name === "Truck Team Lead" || newRole.name === "Truck Labourer") {
            this.props.updateDriverSystem(true, false);
        }

        this.setState({ errors: {} });
        this.props.updateRoles(userRoles);
    }

    //remove role from selected
    removeItem = (id: number) => {
        var userRoles = this.props.userRoles;
        userRoles.splice(userRoles.findIndex(function (i) {
            return i.id == id;
        }), 1);

        this.setState({ errors: {} });
        this.props.updateRoles(userRoles);
    }

    handleBranchChange = (e: any) => {
        var userBranches = this.props.userBranches;
        var newBranch: UserBranches = {
            id: parseInt(e.target.value),
            name: e.target.selectedOptions[0].label
        };
        userBranches.push(newBranch);
        this.setState({ errors: {} });
        this.props.updateBranches(userBranches);
    }

    removeBranchItem = (id: number) => {
        var userBranches = this.props.userBranches;
        userBranches.splice(userBranches.findIndex(function (i) {
            return i.id == id;
        }), 1);

        this.setState({ errors: {} });
        this.props.updateBranches(userBranches);
    }

    handleDriverSytemChange = (e: any) => {
        let skipTruckCheck = this.props.skipTruckToolCheck;
        if (!e.target.checked) {
            skipTruckCheck = false;
        }

        this.props.updateDriverSystem(e.target.checked, skipTruckCheck);
    }

    handleSkipTruckToolCheckChange = (e: any) => {
        this.props.updateDriverSystem(this.props.driverSystem, e.target.checked);
    }

    validate = () => {
        //let fields = this.state.userRoles;
        let errors: any = {};
        let formIsValid = true;

        if (this.props.userRoles.length < 1) {
            formIsValid = false;
            errors["roleId"] = "At least one role is required";
        }

        if (this.props.userBranches.length < 1) {
            formIsValid = false;
            errors["branchId"] = "At least one branch is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUserRoles();


        return (<div>
            {contents}
        </div>);
    }

    renderUserRoles = () => {
        //roles
        let allRoles = this.state.roles;
        let selectedRoles = this.props.userRoles;
        var availRoles = allRoles.filter(function (data) {
            var found = _.find(selectedRoles, { 'id': data.id });
            if (!found) {
                return data;
            }
        });
        //branches
        let allBranches = this.state.branches;
        let selectedBranches = this.props.userBranches;
        var availBranches = allBranches.filter(function (data) {
            var found = _.find(selectedBranches, { 'id': data.id });
            if (!found) {
                return data;
            }
        });

        return (
            <form name="user" onSubmit={this.save}>
                <div>
                    <div className="user__rolebranchsize">
                        <div className="user__rolebranchitemsize">
                            <div className="row">
                                <label className="input-group--inline" htmlFor="role">
                                    <span className="label">Role</span>
                                    <select className="select" id="role" name="roleId" value={this.state.roleId} onChange={(e) => this.handleRoleChange(e)} >
                                        <option defaultValue="-1"></option>
                                        {availRoles.map(role =>
                                            <option key={role.id} value={role.id}>{role.name}</option>
                                        )}
                                    </select>
                                </label>
                                <span className="label errors">{this.state.errors["roleId"]}</span>
                            </div>
                            <div className="row">
                                <label className="input-group--inline" htmlFor="team">
                                    <span className="label"></span>
                                    <div className="allocatepopup__wrapItems">
                                        {selectedRoles.map(role =>
                                            <div className="allocatepopup__nowrapItemText input-group" key={role.id} >
                                                <span className="label">{role.name}</span>
                                                <button type="button" className="close makeitred" onClick={() => this.removeItem(role.id)} >&times;</button>
                                                <br />
                                            </div>
                                        )}
                                    </div>
                                </label>
                            </div>
                            <label className="input-group" htmlFor="driverSystem">
                                <span className="label">Use Driver System</span>
                                <input className="checkbox" type="checkbox" id="driverSystem" name="driverSystem" checked={this.props.driverSystem} onChange={(e) => this.handleDriverSytemChange(e)}></input>
                            </label>
                            <label className={this.props.driverSystem ? "input-group" : "hidden"} htmlFor="skipTruckToolCheck">
                                <span className="label">Skip Truck/Tool Check</span>
                                <input className="checkbox" type="checkbox" id="skipTruckToolCheck" name="skipTruckToolCheck" checked={this.props.skipTruckToolCheck} onChange={(e) => this.handleSkipTruckToolCheckChange(e)}></input>
                            </label>
                        </div>
                        <div className="user__rolebranchitemsize">
                            <div className="row">
                                <label className="input-group--inline" htmlFor="branch">
                                    <span className="label">Branch</span>
                                    <select className="select" id="branch" name="branchId" value={this.state.branchId} onChange={(e) => this.handleBranchChange(e)} >
                                        <option defaultValue="-1"></option>
                                        {availBranches.map(branch =>
                                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                                        )}
                                    </select>
                                </label>
                                <span className="label errors">{this.state.errors["branchId"]}</span>
                            </div>
                            <div className="row">
                                <label className="input-group--inline" htmlFor="team">
                                    <span className="label"></span>
                                    <div className="allocatepopup__wrapItems">
                                        {selectedBranches.map(branch =>
                                            <div className="allocatepopup__nowrapItemText input-group" key={branch.id} >
                                                <span className="label">{branch.name}</span>
                                                <button type="button" className="close makeitred" onClick={() => this.removeBranchItem(branch.id)} >&times;</button>
                                                <br />
                                            </div>
                                        )}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <button className="defaultbutton-next" type="submit">Save</button>
                    </div>

                </div>
            </form>
        );
    }

}
